import {} from 'viem';
import {} from 'viem/zksync';
import { EOA_VALIDATOR_ADDRESS } from '../constants.js';
import { sendPrivyTransaction } from './sendPrivyTransaction.js';
import { sendTransactionInternal } from './sendTransactionInternal.js';
export async function sendTransaction(client, signerClient, publicClient, parameters, isPrivyCrossApp = false, customPaymasterHandler = undefined) {
    if (isPrivyCrossApp) {
        let paymasterData = {};
        // SendEip712TransactionParameters doesn't actually have paymaster or paymasterInput fields
        // defined, so we just have to cast to any here to access them
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestAsAny = parameters;
        if (customPaymasterHandler &&
            !requestAsAny.paymaster &&
            !requestAsAny.paymasterInput) {
            paymasterData = await customPaymasterHandler({
                ...parameters,
                from: client.account.address,
                chainId: parameters.chain?.id ?? client.chain.id,
            });
        }
        const updatedParameters = {
            ...parameters,
            ...paymasterData,
        };
        return await sendPrivyTransaction(client, updatedParameters);
    }
    return sendTransactionInternal(client, signerClient, publicClient, parameters, EOA_VALIDATOR_ADDRESS, {}, customPaymasterHandler);
}
//# sourceMappingURL=sendTransaction.js.map